module.exports = __webpack_public_path__ + "static/media/17.da1df766.jpg";